import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import StudentHeader from "../components/StudentHeader";
import { challengePools } from "../data/studentData";
import { methods } from "../data/methodsData";

const DONE_KEY = "mushtariy_challenges_done";

const slots = [
    { id: "age", label: "Yosh guruhi", pool: challengePools.ages },
    { id: "topic", label: "Mavzu", pool: challengePools.topics },
    { id: "method", label: "Metod", pool: methods.map((m) => m.name) },
    { id: "format", label: "Faoliyat shakli", pool: challengePools.formats },
    { id: "constraint", label: "Ijodiy shart", pool: challengePools.constraints },
];

const pick = (pool) => pool[Math.floor(Math.random() * pool.length)];
const randomAll = () => Object.fromEntries(slots.map((s) => [s.id, pick(s.pool)]));

const readDone = () => {
    try {
        return Number(localStorage.getItem(DONE_KEY)) || 0;
    } catch {
        return 0;
    }
};

function Challenge() {
    const [values, setValues] = useState(randomAll);
    const [locked, setLocked] = useState({});
    const [spinning, setSpinning] = useState(false);
    const [done, setDone] = useState(readDone);
    const [justDone, setJustDone] = useState(false);
    const timer = useRef(null);

    useEffect(() => () => clearInterval(timer.current), []);

    const spin = () => {
        setSpinning(true);
        setJustDone(false);
        let ticks = 0;
        clearInterval(timer.current);
        timer.current = setInterval(() => {
            ticks += 1;
            setValues((prev) => Object.fromEntries(slots.map((s) => [s.id, locked[s.id] ? prev[s.id] : pick(s.pool)])));
            if (ticks >= 12) {
                clearInterval(timer.current);
                setSpinning(false);
            }
        }, 80);
    };

    const markDone = () => {
        const n = done + 1;
        setDone(n);
        setJustDone(true);
        try {
            localStorage.setItem(DONE_KEY, String(n));
        } catch {
            // e'tiborsiz
        }
    };

    const method = methods.find((m) => m.name === values.method);

    return (
        <>
            <StudentHeader title="Ijodiy topshiriq generatori" crumb="Ijodiy topshiriq" />
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Metodik ruletka</h3>
                                <p className="pricing-one__text">
                                    Ruletkani aylantiring — tasodifiy yosh guruhi, mavzu, metod, faoliyat shakli va ijodiy shart tushadi.
                                    Shu shartlar asosida mashg'ulot yoki didaktik o'yin loyihalang. Yoqqan qatorni qulflab, qolganlarini qayta aylantirish mumkin.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5" style={{ paddingBottom: 40 }}>
                            <div className="row gutter-y-20">
                                {slots.map((s) => (
                                    <div className={s.id === "constraint" ? "col-12" : "col-md-6"} key={s.id}>
                                        <div style={{
                                            border: locked[s.id] ? "2px solid #ffb606" : "1px solid #e5e5e5",
                                            background: locked[s.id] ? "#fff8e6" : "#fafafa",
                                            borderRadius: 12, padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, height: "100%"
                                        }}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 13, color: "#999" }}>{s.label}</div>
                                                <div style={{ fontSize: 18, fontWeight: 600, filter: spinning && !locked[s.id] ? "blur(1px)" : "none" }}>
                                                    {values[s.id]}
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => setLocked({ ...locked, [s.id]: !locked[s.id] })}
                                                title={locked[s.id] ? "Qulfni ochish" : "Qulflash"}
                                                style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer" }}
                                            >
                                                {locked[s.id] ? "🔒" : "🔓"}
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="text-center mt-4">
                                <button onClick={spin} disabled={spinning} className="eduhive-btn" style={{ border: "none", opacity: spinning ? 0.6 : 1 }}>
                                    <span>{spinning ? "Aylanmoqda..." : "🎲 Ruletkani aylantirish"}</span>
                                </button>
                            </div>

                            <div style={{ background: "#fafafa", borderLeft: "4px solid #ffb606", borderRadius: 12, padding: 24, marginTop: 30 }}>
                                <h4>Sizning topshirig'ingiz</h4>
                                <p style={{ fontSize: 17 }}>
                                    <strong>{values.age}</strong> bolalari uchun <strong>"{values.topic}"</strong> mavzusida{" "}
                                    <strong>{values.method}</strong> asosida <strong>{values.format}</strong> loyihalang.
                                    Shart: <strong>{values.constraint}</strong>.
                                </p>
                                <h5 className="mt-3">Bajarish tartibi</h5>
                                <ol style={{ paddingLeft: 20, color: "#444" }}>
                                    <li>SMART talablariga mos mashg'ulot maqsadini yozing.</li>
                                    <li>
                                        {method ? <Link to={method.path} style={{ color: "#ffb606" }}>{method.name}</Link> : values.method} bosqichlarini
                                        faoliyat shakliga moslab, bosqichma-bosqich ssenariy tuzing.
                                    </li>
                                    <li>Kerakli jihozlar ro'yxatini ijodiy shartni hisobga olib tuzing.</li>
                                    <li>Bolalar natijasini qanday kuzatib baholashingizni belgilang.</li>
                                    <li>Guruhdoshlaringizga taqdim eting va refleksiv kundalikka xulosa yozing.</li>
                                </ol>
                                <div className="d-flex mt-3" style={{ gap: 12, flexWrap: "wrap" }}>
                                    <Link to="/planner" className="eduhive-btn">
                                        <span>Mashg'ulot rejasini tuzish</span>
                                    </Link>
                                    <button onClick={markDone} disabled={justDone} className="eduhive-btn" style={{ border: "none", background: justDone ? "#10b981" : "#666" }}>
                                        <span>{justDone ? "✓ Bajarildi" : "Bajardim"}</span>
                                    </button>
                                </div>
                                <p style={{ fontSize: 14, color: "#999", marginTop: 12, marginBottom: 0 }}>
                                    Bajarilgan ijodiy topshiriqlar: <strong>{done}</strong>
                                    {done >= 10 ? " 🏆 Ijodkor tarbiyachi!" : done >= 5 ? " 🥈 Faol izlanuvchi" : done >= 1 ? " 🌱 Yaxshi boshlanish" : ""}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Challenge;
